import React from 'react';
import { Provider } from 'react-redux';
import store from '../../Redux/store';
import CoderHistoryLib from './lib/coder-history';

function app(props) {
  return (
    <Provider store={store}>
      <CoderHistoryLib rowInfo={props.rowInfo} applicationId={props.applicationId} />
    </Provider>
  );
}

export const CoderHistory = app;
